import React from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../Hooks/useAuth";
import { useAppSelector } from "../redux/hooks/hook";
import { selectCurrentToken, selectCurrentUser, selectIs2FARequired, selectIs2FAValidated } from "../redux/features/auth/authSlice";
import TwoFAValidation from "../Components/TwoFAValidation";

const PrivateRoute = () => {
  const { auth } = useAuth();
  const location = useLocation();
  const curUser = useAppSelector(selectCurrentUser);
  const curToken = useAppSelector(selectCurrentToken);
  const is2FARequired = useAppSelector(selectIs2FARequired)
  const is2FAValidated = useAppSelector(selectIs2FAValidated)
  /* const [login, setLogin] = useState(JSON.parse(localStorage.getItem("login")));
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    setAuthenticated(JSON.parse(localStorage.getItem("authenticated")));
    localStorage.setItem("authenticated", authenticated);
    localStorage.setItem("login", login);
  }, []);

  return login || authenticated ? <Outlet /> : <Navigate exact to={`${process.env.PUBLIC_URL}/login`} />;
 */
  //console.log('Auth Cred:', auth?.accessToken);
  //console.log('Auth Cred:', auth?.user?.email);

  if (curUser && curToken) {
    // If the user exists and token exists, check if 2FA is required
    if (is2FARequired && !is2FAValidated) {
      // Redirect to OTP page if 2FA is required
      //return "OTP is required";
      return (
        <TwoFAValidation />
      )
      //return <Navigate to="/otp" state={{ from: location }} replace />;
    }

    // If 2FA is not required, render the protected content (Outlet)
    return <Outlet />;
  }

  // If no user or token, redirect to login page
  return <Navigate to={`${process.env.PUBLIC_URL}/login`} state={{ from: location }} replace />;

  /* return (
    //auth?.roles?.find(role => allowedRoles?.includes(role))
    //(auth?.accessToken && auth?.user)
    (curUser && curToken)
        ? <Outlet />
          //: auth?.user
          //  ? <Navigate to="/unauthorized" state={{ from: location }} replace /> 
            : <Navigate exact to={`${process.env.PUBLIC_URL}/login`} state={{ from: location }} replace />
  ); */
};

export default PrivateRoute;
